export default __webpack_public_path__ + "static/media/ilustracion.47a5c24e.svg";